import React from 'react';
import Fade from 'react-reveal/Fade';
import ContactSection from '../components/ContactSection';
import Map from '../components/Map';

export default function Contact() {
  return (
    <>
      <Fade>
        <ContactSection />
      </Fade>
      <Fade>
        <Map />
      </Fade>
    </>
  );
}
